module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-form-table', {
    staticClass: "clientcontacts-table",
    attrs: {
      "form": _vm.form,
      "list": _vm.currentClientContacts,
      "create": _vm.save,
      "update": _vm.update,
      "destroy": _vm.destroy,
      "noResultWarningText": _vm.$t('form.clients.noContactWarning'),
      "translation": "form.clients",
      "primaryContactError": _vm.primaryContactError,
      "hiddenFields": _vm.hiddenFields
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-171f6ff7","hasScoped":false}!./src/app/components/clientContact/clientContact.html
// module id = 2923
// module chunks = 1